import React from 'react';

import { useTranslation } from 'react-i18next';
import styleSheet from '../../../scorePredictor/components/styles/scorePredictor.module.scss';

import SignInIcon from '../icons/SignInIcon';
import RefreshIcon from '../icons/RefreshIcon';
const styles = styleSheet.locals || {};
/**
 * SignInGate component
 *
 * @returns {React.Element} The rendered sign-in gate component.
 */
function SignInGate() {
    const { t } = useTranslation();

    const handleRefreshClick = () => {
        window.location.reload();
    };

    const handleBtnClick = () => {
        if (window?.Playbook?.setSSORedirect) {
            window.Playbook.setSSORedirect();
        }

        if (window?.Playbook?.RegisterLink) {
            window.location.href = window.Playbook.RegisterLink;
        } else if (window?.Playbook?.SignInLink) {
            window.location.href = window.Playbook.SignInLink;
        } else {
            // fallback to the wta login page
            window.location.href = '/login';
        }
    };

    const isWTA = window.location.host.includes('wta');
    const signInMessage = t('signInGate.alreadySignedIn');

    return (
        <div part="score-predictor-gate" className={styles.scorePredictorGate}>
            <div className={styles.scorePredictorGateText}>
                <div className={styles.scorePredictorGateIcon}>
                    <SignInIcon />
                </div>

                {isWTA ? (
                    <button
                        part="score-predictor-gate-button"
                        className={styles.scorePredictorGateBtn}
                        onClick={handleBtnClick}
                        title={signInMessage}
                    >
                        {signInMessage}
                    </button>
                ) : (
                    <div className={styles.scorePredictorGateTitle}>
                        {signInMessage}
                    </div>
                )}

                <div className={styles.scorePredictorGateSubtitle}>
                    {t('signInGate.alreadySignedIn')}
                    <div
                        onClick={handleRefreshClick}
                        className={styles.scorePredictorGateRefreshWrapper}
                    >
                        <span className={styles.scorePredictorGateRefresh}>
                            {t('signInGate.refreshBrowser')}
                        </span>
                        <span className={styles.scorePredictorGateRefreshIcon}>
                            <RefreshIcon />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SignInGate;
